import { VscAdd } from '@react-icons/all-files/vsc/VscAdd'
import { VscClose } from '@react-icons/all-files/vsc/VscClose'
import React, { useRef, useState } from 'react'

interface MultiImagesUploadProps {
  onChange: (images: File[]) => void
  tooltipTargetClassName?: string
  disabled?: boolean
}

export default function MultiImagesUpload({
  onChange,
  tooltipTargetClassName,
  disabled = false
}: MultiImagesUploadProps) {
  const [images, setImages] = useState<File[]>([])
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return

    const files = Array.from(e.target.files || [])
    const newImages = [...images, ...files]
    setImages(newImages)
    onChange(newImages)
  }

  const handleRemoveImage = (index: number) => {
    if (disabled) return
    const newImages = images.filter((_, i) => i !== index)
    setImages(newImages)
    onChange(newImages)
  }

  const handleAddClick = () => {
    if (disabled) return
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <div className='flex flex-wrap gap-4'>
      {images.map((image, index) => (
        <div key={index} className='relative w-24 h-24'>
          <img
            src={URL.createObjectURL(image)}
            alt={`Upload ${index + 1}`}
            className='w-full h-full object-cover rounded-lg'
          />
          <button
            onClick={() => handleRemoveImage(index)}
            className='absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 flex items-center justify-center'
            aria-label='Remove image'
            disabled={disabled}
          >
            <VscClose size={16} />
          </button>
        </div>
      ))}
      <button
        onClick={handleAddClick}
        className={`w-24 h-24 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center ${tooltipTargetClassName} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        aria-label='Add image'
        disabled={disabled}
      >
        <VscAdd size={24} className='text-gray-400' />
      </button>
      <input
        type='file'
        ref={fileInputRef}
        onChange={handleFileChange}
        accept='.png,.jpg,.jpeg'
        multiple
        className='hidden'
        disabled={disabled}
      />
    </div>
  )
}
